module.exports = __webpack_public_path__ + "media/apps/gif-ios-12-firstframe-ae15691f.jpg";